import { Box, FormHelperText, Typography } from '@mui/material';
import type { FieldAdapterProps } from '../../../runtime/forms/field-adapter-registry';
import { resolveTKey, translateRuntimeTKeyOrFallback } from '../../../i18n/resolve-key';
import { maskValue } from '../../../runtime/forms/sensitive-value-policy';

export function MaskedValueAdapter(props: FieldAdapterProps) {
  const { field, state, serverError, describedBy, t } = props;
  const label = t(resolveTKey(field.labelKey));
  const maskedValue = maskValue('protected');
  const reason = state.reasonKey ? t(resolveTKey(state.reasonKey)) : undefined;
  const displayServerError = serverError
    ? translateRuntimeTKeyOrFallback(t, serverError)
    : undefined;
  const internalHelp = displayServerError ?? reason;
  const internalHelpId = internalHelp ? `${field.name}-masked-helper` : undefined;
  const ariaDescribedBy = [describedBy, internalHelpId].filter(Boolean).join(' ') || undefined;

  return (
    <Box component="dl" sx={{ m: 0, minWidth: 0, width: '100%' }}>
      <Typography
        component="dt"
        variant="caption"
        sx={{
          display: 'block',
          mb: 0.5,
          color: 'text.secondary',
          fontWeight: 600,
          letterSpacing: '0.01em',
          overflowWrap: 'anywhere',
        }}
      >
        {label}
      </Typography>
      <Typography
        component="dd"
        variant="body2"
        sx={{
          m: 0,
          px: 1.75,
          py: 1.25,
          border: 1,
          borderColor: 'divider',
          borderRadius: 1,
          backgroundColor: 'action.disabledBackground',
          minHeight: 56,
          minWidth: 0,
          display: 'flex',
          alignItems: 'center',
          fontWeight: 500,
          letterSpacing: '0.25em',
          overflow: 'hidden',
        }}
        aria-describedby={ariaDescribedBy}
      >
        {maskedValue}
      </Typography>
      {internalHelp && (
        <FormHelperText id={internalHelpId} error={Boolean(displayServerError)} sx={{ mt: 0.75 }}>
          {internalHelp}
        </FormHelperText>
      )}
    </Box>
  );
}
